import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ChipContainer = styled(Grid)({
  paddingTop: 0.5,
  paddingBottom: 0.5,
  margin: 0,
  "& .MuiGrid-root": {
    paddingLeft: 0,
  },
});
